import React from "react";
import "./CertificateInfoSection.scss";

const CertificateInfoSection = ({
  title = "Contract Name",
  description = "",
  collectionImage = "",
  serialNumber = "",
  edition = "",
  issuedBy = "",
  date = "",
}) => {
  return (
    <section className="certificate-section">
      <div className="certificate-top">
        <div className="certificate-content">
          <h2>{title}</h2>

          <p>{description}</p>
        </div>

        <div className="certificate-image">
          {collectionImage ? (
            <img src={collectionImage} alt={title} />
          ) : (
            <div className="placeholder">Collection Image</div>
          )}
        </div>
      </div>

      <div className="certificate-divider" />

      <div className="certificate-bottom">
        <h3>Certificate Information</h3>

        <div className="certificate-grid">
          <div className="certificate-row">
            <span className="label">Certificate Serial Number</span>
            <span className="value">{serialNumber}</span>
          </div>

          <div className="certificate-row">
            <span className="label">Number of the Certificate Edition</span>
            <span className="value">{edition}</span>
          </div>

          <div className="certificate-row">
            <span className="label">Issued by</span>
            <span className="value">{issuedBy}</span>
          </div>

          <div className="certificate-row">
            <span className="label">Date</span>
            <span className="value">{date}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CertificateInfoSection;
